import { Aluno } from '@/pages/admin/entities/aluno.entity'
import styles from '../student.admin.module.scss'

export interface IStudentProps {
  student: Aluno
}

export const StudentList = ({ student }: IStudentProps) => {
  return (
    <>
      <h1>Aluno</h1>
      <div className={styles.students}>
        {student &&
          Object.keys(student).map((key) => {
            return (
              <div className={styles.student_content}>
                <strong>{key}:</strong> <span>{student[key]}</span>
              </div>
            )
          })}
      </div>
    </>
  )
}
